import 'packages/lib/common-ui/toast/react-toastify-overrides.css';
import { FC } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const ToastMessageContainer: FC<
  React.PropsWithChildren<unknown>
> = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        zIndex: 9999,
      }}
    >
      <div id="message-container">
        <ToastContainer autoClose={2000} limit={10} />
      </div>
    </div>
  );
};
